import {YANDEX_METRIKA_ID} from '@web-landing/analytics/ids';

export type YA_METRIKA_DOMAINS_TYPE =
  | 'help'
  | 'apps'
  | 'games'
  | 'developers'
  | 'to_main';
export const YA_METRIKA_DOMAINS = {
  help: '311741651',
  apps: '311741675',
  games: '311741679',
  developers: '311741763',
  to_main: '311741768',
};

export const ym_log = {
  headerMenuButtonYM: () => {
    window.ym(YANDEX_METRIKA_ID, 'reachGoal', 'header_menu_button', {
      domain_311741561: location.host,
    });
  },

  headerMenuButtonDownloadYM: () => {
    window.ym(YANDEX_METRIKA_ID, 'reachGoal', 'header_menu_button_download', {
      domain_311741561: location.host,
    });
  },

  headerMenuButtonLogoYM: () => {
    window.ym(YANDEX_METRIKA_ID, 'reachGoal', 'header_menu_button_logo', {
      domain_311741787: location.host,
    });
  },

  headerMenuButtonClickYM: (item: YA_METRIKA_DOMAINS_TYPE) => {
    const ym_domain: Record<string, string> = {};
    ym_domain[`domain_${YA_METRIKA_DOMAINS[item]}`] = location.host;

    window.ym(
      YANDEX_METRIKA_ID,
      'reachGoal',
      `header_menu_button_${item}`,
      ym_domain,
    );
  },
};
